<div class="m-4 px-6 py-8 bg-white rounded-lg flex flex-col gap-6">
  <div class="flex flex-col gap-y-7 w-full">
    <div class="lg:px-8 px-0 pb-4 pt-8 bg-white border-[--brand-azul-primario] border-t">
      <div class="grid gap-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 items-center">
        <app-input-general
          class="col-span-2"
          [label]="'general-pages.promise-letter.amountWithVat' | translate"
          [placeholder]="'general-pages.promise-letter.amountWithVat' | translate"
          [mask]="'separator'"
          [prefix]="'$'"
          [thousandSeparator]="','"
          [allowNegativeNumbers]="true"
          [formControlGeneral]="ballon"
        ></app-input-general>

        <button
          [disabled]="ballon.invalid"
          (click)="getCartaPromesa()"
          class="button-general text-center !w-auto h-12.75 mt-2 col-span-2"
          matButton="filled"
        >
          {{ 'general-pages.promise-letter.accept' | translate }}
        </button>

        @if (field) {
          <div class="w-full col-span-full">
            <app-reader-pdf [pdfReader]="field"></app-reader-pdf>
          </div>
        }
      </div>
    </div>
  </div>
</div>
